/**
 * The dock layout, for the parts of the UI that live inside it.
 *
 * The manager is created by `App` and handed here, the same way the engine
 * bridge holds the Engine: a live handle, not store state.
 */

import type { DockManager } from "@tredespace/ui/dockable";
import { setHud } from "../hud/hud.actions.ts";

let manager: DockManager | null = null;

export function bindDockManager(bound: DockManager): void {
  manager = bound;
}

/** Put every panel back where it started — the way to recover a panel that was closed. */
export function resetPanels(): void {
  if (!manager) {
    return;
  }

  manager.resetLayout();
  setHud("Panels reset to the default layout");
}
